module.exports = __webpack_public_path__ + "assets/img/thumb-superdraft-video.0437fa1f.webp";